const SvgVoxboxNarrow = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 31 32">
    <path d="m15.738 1.135 13.443 8.226v13.083l-13.443 8.025-13.443-8.025V9.361zM2.82 9.655v12.178l12.656-7.556V1.91zM16 1.911v12.367l12.656 7.556V9.656zm12.406 20.384-12.669-7.563-12.669 7.563 12.669 7.563z" />
  </svg>;
export default SvgVoxboxNarrow;